import React from 'react';
import { Scanner } from '@yudiel/react-qr-scanner';

interface QRScannerProps {
  onScan: (result: string) => void;
  isProcessing: boolean;
  onError?: (error: string) => void;
  onReset?: () => void;
}

const QRScanner: React.FC<QRScannerProps> = ({ onScan, isProcessing, onError, onReset }) => {
  const handleScan = (detectedCodes: any[]) => {
    if (detectedCodes && detectedCodes.length > 0) {
      const result = detectedCodes[0].rawValue;
      console.log('QR Code detected:', result);
      onScan(result);
    }
  };

  const handleError = (error: unknown) => {
    console.error('QR Scanner error:', error);
    if (onError) {
      onError(error instanceof Error ? error.message : String(error));
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-4 md:p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg md:text-xl font-semibold text-gray-800">QR Code Scanner</h2>
        {onReset && (
          <button
            onClick={onReset}
            className="bg-gray-500 text-white px-3 py-1.5 rounded-lg hover:bg-gray-600 transition-colors duration-200 text-sm font-medium"
          >
            Reset Scanner
          </button>
        )}
      </div>
      
      <div className="relative">
        <Scanner
          onScan={handleScan}
          onError={handleError}
          components={{
            finder: true,
          }}
          styles={{
            container: {
              width: '100%',
              maxWidth: '400px',
              margin: '0 auto',
            },
            video: {
              width: '100%',
              borderRadius: '8px',
            },
          }}
        />
        
        {/* Processing indicator */}
        {isProcessing && (
          <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center rounded-lg">
            <div className="bg-white p-4 rounded-lg">
              <p className="text-gray-800">Processing...</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default QRScanner;